import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const AdminLogin = () => {
  const navigate = useNavigate();
  const { signInWithGoogle, authError, clearAuthError } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  // Check for URL error parameters
  React.useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const hashParams = new URLSearchParams(window.location.hash.substring(1));
    const errorCode =
      urlParams.get("error_code") || hashParams.get("error_code");

    // Only show error for specific error codes that indicate access issues
    if (errorCode === "signup_disabled" || errorCode === "access_denied") {
      setError("אין לך הרשאה לגשת לפאנל הניהול. אנא פנה למנהל המערכת.");

      // Clean up URL parameters and hash
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  const handleGoogleSignIn = async () => {
    setIsLoading(true);
    setError("");
    clearAuthError(); // Clear any previous auth errors

    try {
      await signInWithGoogle();
    } catch (err) {
      setError("שגיאה בהתחברות עם Google");
      console.error("Google sign-in error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  // Clear auth error when component mounts or when user clicks sign in
  React.useEffect(() => {
    if (authError) {
      // Clear the error after 5 seconds
      const timer = setTimeout(() => {
        // The error will be cleared by the auth context on next auth event
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [authError]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-100 via-purple-50 to-yellow-100 flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="bg-white/70 backdrop-blur-sm rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10 lg:p-12 shadow-xl border border-pink-100">
          <div className="text-center">
            <img
              src="/oz_and_tali.png"
              alt="Logo"
              className="h-24 mx-auto mb-4"
            />
            <h2
              className="text-2xl sm:text-3xl font-bold text-gray-800 mb-6"
              dir="rtl"
            >
              פאנל ניהול
            </h2>
            <p className="text-lg text-gray-700 mb-8" dir="rtl">
              התחבר עם Google כדי לגשת לפאנל הניהול
            </p>
          </div>

          <div className="space-y-6">
            {(error || authError) && (
              <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                <p
                  className="text-red-700 text-sm text-center font-medium"
                  dir="rtl"
                >
                  {error || authError}
                </p>
              </div>
            )}

            <button
              onClick={handleGoogleSignIn}
              disabled={isLoading}
              className="w-full px-6 py-3 bg-white text-gray-700 font-bold text-lg rounded-lg border-2 border-gray-300 hover:border-gray-400 hover:bg-gray-50 transition-all duration-200 transform hover:scale-105 disabled:opacity-50 flex items-center justify-center space-x-3"
            >
              {isLoading ? (
                <>
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-gray-500"></div>
                  <span>טוען...</span>
                </>
              ) : (
                <>
                  <span dir="rtl">התחבר עם Google</span>
                  <svg className="w-5 h-5" viewBox="0 0 24 24">
                    <path
                      fill="#4285F4"
                      d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                    />
                    <path
                      fill="#34A853"
                      d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                    />
                    <path
                      fill="#FBBC05"
                      d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                    />
                    <path
                      fill="#EA4335"
                      d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                    />
                  </svg>
                </>
              )}
            </button>
          </div>

          <hr className="my-6 border-gray-300" />
          <button
            onClick={() => navigate("/")}
            className="w-full px-6 py-3 text-center text-gray-700 border border-gray-300 rounded-lg"
          >
            חזור לדף הבית
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
